import SEO from "../components/SEO";
import Hero from "../sections/Hero";
import ProblemSection from "../sections/ProblemSection";
import DemoSection from "../sections/DemoSection";
import WorkflowSection from "../sections/WorkflowSection";
import FeatureShowcase from "../sections/FeatureShowcase";
import BuiltForVAs from "../sections/BuiltForVAs";
import SimpleFromDayOne from "../sections/SimpleFromDayOne";
import IntegrationsGrid from "../sections/IntegrationsGrid";
import ProductTourTeaser from "../sections/ProductTourTeaser";
import PricingPreview from "../sections/PricingPreview";
import SecurityTrust from "../sections/SecurityTrust";
import FinalCTA from "../sections/FinalCTA";

export default function Home() {
  return (
    <>
      <SEO
        title="The business workspace built for virtual assistants"
        description="ClientDesk VA replaces spreadsheets, calendars, forms, booking tools and invoicing with one organized workspace for virtual assistants and independent service professionals."
        path="/"
      />
      <Hero />
      <ProblemSection />
      <DemoSection />
      <WorkflowSection />
      <FeatureShowcase />
      <BuiltForVAs />
      <SimpleFromDayOne />
      <IntegrationsGrid />
      <ProductTourTeaser />
      <PricingPreview compact />
      <SecurityTrust />
      <FinalCTA />
    </>
  );
}
